import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const DownloadFile: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.195 13.23 9.78 14.645h-.005l6.72 6.72 6.72-6.72L21.8 13.23l-4.305 4.305V6.76h-2v10.77l-4.3-4.3Zm-2.96 10.01H24.77v2H8.235v-2Z"
      clipRule="evenodd"
    />
  </Icon>
);
